// @ts-expect-error - @rails/activestorage doesn't have TypeScript definitions
import * as ActiveStorage from "@rails/activestorage"

ActiveStorage.start()

// Webpack's require.context for loading images
// eslint-disable-next-line @typescript-eslint/no-explicit-any
;(require as any).context("../images", true)

import "../stylesheets/application.scss"
import "../channels"

import { createRoot } from "react-dom/client"

import App from "~/App"

document.addEventListener("DOMContentLoaded", () => {
  const appElement = document.getElementById("app")
  if (appElement) {
    const root = createRoot(appElement)
    root.render(<App />)
  }
})
